// Author Lin
// Date 2021-11-20 09:49:55

class MintalMesPrdPelletizingWaterSystemParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                softWaterLevel = '',
                softWaterTemp = '',
                softWaterPressure = '',
                softWaterFlow = '',
                cleanRingPressure = '',
                cleanRingFlow = '',
                productionPumpPressure = '',
                productionPumpFlow = '',
                turbidRingPressure = '',
                turbidRingFlow = '',
                newWaterPressure = '',
                newWaterFlow = '',
                underflowPumpPressure = '',
                thickenerPressure = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.softWaterLevel = softWaterLevel;
            this.softWaterTemp = softWaterTemp;
            this.softWaterPressure = softWaterPressure;
            this.softWaterFlow = softWaterFlow;
            this.cleanRingPressure = cleanRingPressure;
            this.cleanRingFlow = cleanRingFlow;
            this.productionPumpPressure = productionPumpPressure;
            this.productionPumpFlow = productionPumpFlow;
            this.turbidRingPressure = turbidRingPressure;
            this.turbidRingFlow = turbidRingFlow;
            this.newWaterPressure = newWaterPressure;
            this.newWaterFlow = newWaterFlow;
            this.underflowPumpPressure = underflowPumpPressure;
            this.thickenerPressure = thickenerPressure;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingWaterSystemParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'softWaterLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.softWaterLevel',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'softWaterTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.softWaterTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'softWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.softWaterPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'softWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.softWaterFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cleanRingPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.cleanRingPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cleanRingFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.cleanRingFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionPumpPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.productionPumpPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionPumpFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.productionPumpFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'turbidRingPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.turbidRingPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'turbidRingFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.turbidRingFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'newWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.newWaterPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'newWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.newWaterFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'underflowPumpPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.underflowPumpPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'thickenerPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.thickenerPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            softWaterLevelFilter : '',
            softWaterTempFilter : '',
            softWaterPressureFilter : '',
            softWaterFlowFilter : '',
            cleanRingPressureFilter : '',
            cleanRingFlowFilter : '',
            productionPumpPressureFilter : '',
            productionPumpFlowFilter : '',
            turbidRingPressureFilter : '',
            turbidRingFlowFilter : '',
            newWaterPressureFilter : '',
            newWaterFlowFilter : '',
            underflowPumpPressureFilter : '',
            thickenerPressureFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'softWaterLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.softWaterLevel',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'softWaterTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.softWaterTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'softWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.softWaterPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'softWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.softWaterFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cleanRingPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.cleanRingPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cleanRingFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.cleanRingFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'productionPumpPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.productionPumpPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'productionPumpFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.productionPumpFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'turbidRingPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.turbidRingPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'turbidRingFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.turbidRingFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'newWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.newWaterPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'newWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.newWaterFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'underflowPumpPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.underflowPumpPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'thickenerPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.thickenerPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingWaterSystemParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingWaterSystemParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        